/**
 * Supabase Client Instance
 *
 * Singleton instance of the Supabase JS client.
 * Hosted Supabase client — powers auth + database for the app.
 */

import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { config } from '@/config';

export const supabase: SupabaseClient = createClient(config.supabase.url, config.supabase.anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'pauls-models-auth',
  },
});

export default supabase;
